import { api } from "@/lib/api";

export function isPushSupported() {
    return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

export function isStandalone() {
    return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}

function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; i++) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

export async function getExistingSubscription() {
    if (!isPushSupported()) return null;
    const registration = await navigator.serviceWorker.ready;
    return registration.pushManager.getSubscription();
}

export async function subscribeToPush() {
    if (!isPushSupported()) {
        throw new Error(
            isIOS()
                ? "No iPhone, adicione o app à Tela de Início antes de ativar notificações."
                : "Esse navegador não suporta notificações.",
        );
    }
    if (isIOS() && !isStandalone()) {
        throw new Error("No iPhone, adicione o app à Tela de Início (compartilhar → Adicionar à Tela de Início) antes de ativar notificações.");
    }

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
        throw new Error("Permissão de notificação negada.");
    }

    const registration = await navigator.serviceWorker.ready;
    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
        const { data } = await api.get("/push/vapid-public-key");
        if (!data?.publicKey) {
            throw new Error("Notificações push não configuradas no servidor.");
        }
        subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(data.publicKey),
        });
    }

    await api.post("/push/subscribe", subscription.toJSON());
    return subscription;
}

export async function unsubscribeFromPush() {
    const subscription = await getExistingSubscription();
    if (!subscription) return;
    await api.post("/push/unsubscribe", { endpoint: subscription.endpoint });
    await subscription.unsubscribe();
}
